export default __webpack_public_path__ + "static/media/art-red-4.4d48af7e.png";